import useAppNavigate from '@effects/useAppNavigate';
import useResetConsignment from '@effects/useResetConsignment';
import { actionTypes, useGlobalState } from '@state';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

const useSaveOnExit = () => {
    const navigate = useAppNavigate();
    const location = useLocation();
    const [{ generic }, dispatch] = useGlobalState();
    const resetGlobalConsignment = useResetConsignment();

    return useCallback(
        (toPath: string, newTab?: boolean) => {
            if (!generic?.exitingNavigation && location.pathname.startsWith('/consignments/edit')) {
                dispatch({
                    type: actionTypes.generic.setNavigation,
                    value: { payload: { toPath, exitingNavigation: true } },
                });
            } else {
                if (toPath.startsWith('http')) {
                    if (newTab) window.open(toPath, '_blank');
                    else window.location.href = toPath;
                } else {
                    resetGlobalConsignment();
                    navigate(toPath);
                }
            }
        },
        [generic, dispatch, navigate, location.pathname, resetGlobalConsignment]
    );
};

export default useSaveOnExit;
